import { logger } from '@/lib/logger';

// Lazy loaders for export libraries
let jsPDFModule: any = null;
let html2canvasModule: any = null;
const loadingPromises: {
  jsPDF: Promise<any> | null;
  html2canvas: Promise<any> | null;
} = {
  jsPDF: null,
  html2canvas: null
};

export async function loadJsPDF() {
  if (jsPDFModule) {
    return jsPDFModule;
  }

  if (loadingPromises.jsPDF) {
    return loadingPromises.jsPDF;
  }

  loadingPromises.jsPDF = (async () => {
    try {
      logger.log('Lazy loading jsPDF...');
      // Vite will create a separate chunk for this
      const module = await import(/* webpackChunkName: "jspdf" */ 'jspdf');
      jsPDFModule = module;
      logger.log('jsPDF loaded successfully');
      return module;
    } catch (error) {
      logger.error('Failed to load jsPDF:', error);
      loadingPromises.jsPDF = null;
      throw error;
    }
  })();

  return loadingPromises.jsPDF;
}

export async function loadHtml2Canvas() {
  if (html2canvasModule) {
    return html2canvasModule;
  }

  if (loadingPromises.html2canvas) {
    return loadingPromises.html2canvas;
  }

  loadingPromises.html2canvas = (async () => {
    try {
      logger.log('Lazy loading html2canvas...');
      // Vite will create a separate chunk for this
      const module = await import(/* webpackChunkName: "html2canvas" */ 'html2canvas');
      html2canvasModule = module.default || module;
      logger.log('html2canvas loaded successfully');
      return html2canvasModule;
    } catch (error) {
      logger.error('Failed to load html2canvas:', error);
      loadingPromises.html2canvas = null;
      throw error;
    }
  })();

  return loadingPromises.html2canvas;
}

export async function loadExportLibraries() {
  const [jsPDF, html2canvas] = await Promise.all([
    loadJsPDF(),
    loadHtml2Canvas()
  ]);
  
  return { jsPDF, html2canvas };
}